<template>
  <div :class="`queue${isQueueOpened ? ' opened' : ''}`">
    <div class="queue__header">
      <div class="queue__header--left" @click="toggleQueue">
        <div class="queue__closeIcon">
          <ArrowRight />
        </div>
        <div
          class="queue__notify"
          :title="`${queueList.length} solicitaç${
            queueList.length == 1 ? 'ão' : 'ões'
          }`"
        >
          <Bell />
          <span :class="`queue__notify--count${!hasQueue ? ' empty' : ''}`">
            <span>
              {{ queueList.length }}
            </span>
          </span>
        </div>
      </div>
      <div class="queue__header--right">
        <div class="queue__title">
          <span class="queue__title--text"> Alerta de atendimentos </span>
        </div>
      </div>
    </div>

    <div class="queue__body">
      <div class="queue__tabs">
        <button
          :class="`queue__tab${!filtered ? ' actived' : ''}`"
          @click="setFilter(false)"
        >
          <div class="queue__tab--text">Imediatos</div>
        </button>
        <button
          :class="`queue__tab${filtered ? ' actived' : ''}`"
          @click="setFilter(true)"
        >
          <div class="queue__tab--text">Especialidades</div>
        </button>
      </div>

      <div class="queue__list">
        <QueueItem
          v-for="queueItem in queueList"
          :key="queueItem.id"
          :item="queueItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArrowRight from '@/assets/arrow-small-right.svg';
import Bell from '@/assets/bell.svg';
import QueueItem from './QueueItem';
import { mapActions, mapState } from 'vuex';
import notificationSound from '@/assets/sounds/iphone_notification.mp3';
import { Howl } from 'howler';

const soundOptions = {
  src: [notificationSound],
  autoplay: false,
  loop: false,
};

export default {
  name: 'Queue',
  components: { ArrowRight, Bell, QueueItem },

  data: () => ({
    previousQueueLength: null,
    notificationSound: new Howl(soundOptions),
  }),

  computed: {
    ...mapState('queue', {
      queueList: ({ queueList }) => queueList,
      filtered: ({ filtered }) => filtered,
      isQueueOpened: ({ isQueueOpened }) => isQueueOpened,
    }),
    hasQueue() {
      return this.queueList.length > 0;
    },
  },

  watch: {
    filtered() {
      this.fetchQueue();
    },
    queueList(list) {
      const { previousQueueLength, notificationSound } = this;

      if (previousQueueLength !== null && list.length > previousQueueLength) {
        notificationSound.play();
      }

      this.previousQueueLength = list.length;
    },
  },

  created() {
    this.fetchQueue();
    this.interval = setInterval(this.fetchQueue, 30000);
    this.connectSocket();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    ...mapActions('queue', [
      'fetchQueue',
      'connectSocket',
      'setFilter',
      'toggleQueue',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
